import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=7f5faccc&"
import script from "./layout.ts?vue&type=script&lang=ts&"
export * from "./layout.ts?vue&type=script&lang=ts&"
import style0 from "./layout.vue?vue&type=style&index=0&id=7f5faccc&prod&layout=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports